import React from 'react';

import { FormattedMessage } from 'react-intl';

import Button from '@atlaskit/button/new';
import ChevronRightIcon from '@atlaskit/icon/core/chevron-right';

import { useIsTranslationSupportEnabled } from '../../../../controllers/use-is-translation-support-enabled/use-is-translation-support-enabled';
import { useManageTranslationsOpen } from '../manage-translations-open-context';
import { useSupportedLanguages } from '../use-supported-languages/use-supported-languages';

import { messages } from './messages';

export type ManageTranslationsButtonProps = {
	/**
	 * When provided, opens the view scoped to this item (e.g. a carousel card) so only
	 * that item's fields are shown. Omit to show the whole extension's fields.
	 */
	itemId?: string;
};

export const ManageTranslationsButton = ({
	itemId,
}: ManageTranslationsButtonProps = {}): React.JSX.Element | null => {
	const { languages: supportedTranslationLanguages = {} } = useSupportedLanguages();
	const { open } = useManageTranslationsOpen();
	const isTranslationEnabled = useIsTranslationSupportEnabled();

	if (!isTranslationEnabled) {
		return null;
	}

	if (Object.keys(supportedTranslationLanguages).length === 0) {
		return null;
	}

	return (
		<Button iconAfter={ChevronRightIcon} onClick={() => open(itemId)}>
			<FormattedMessage {...messages.buttonLabel} />
		</Button>
	);
};
